// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__LxjVr","text":"SelectPayment_text__1L8hh","title":"SelectPayment_title__3_E6s","btn":"SelectPayment_btn__1OxQ0"};